"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var core_2 = require("@material-ui/core");
var KeyboardArrowLeft_1 = tslib_1.__importDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var KeyboardArrowRight_1 = tslib_1.__importDefault(require("@material-ui/icons/KeyboardArrowRight"));
var Event_1 = tslib_1.__importDefault(require("@material-ui/icons/Event"));
var pickers_1 = require("@material-ui/pickers");
var dayjs_1 = tslib_1.__importDefault(require("@date-io/dayjs"));
var util_1 = require("../util");
var MaterialDateControl = /** @class */ (function (_super) {
    tslib_1.__extends(MaterialDateControl, _super);
    function MaterialDateControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialDateControl.prototype.render = function () {
        var _a, _b;
        var _c = this.props, description = _c.description, id = _c.id, errors = _c.errors, label = _c.label, uischema = _c.uischema, visible = _c.visible, enabled = _c.enabled, required = _c.required, path = _c.path, handleChange = _c.handleChange, data = _c.data, config = _c.config;
        var isValid = errors.length === 0;
        var appliedUiSchemaOptions = merge_1.default({}, config, uischema.options);
        var showDescription = !core_1.isDescriptionHidden(visible, description, this.state.isFocused, appliedUiSchemaOptions.showUnfocusedDescription);
        var format = (_a = appliedUiSchemaOptions.dateFormat) !== null && _a !== void 0 ? _a : 'YYYY-MM-DD';
        var saveFormat = (_b = appliedUiSchemaOptions.dateSaveFormat) !== null && _b !== void 0 ? _b : 'YYYY-MM-DD';
        var firstFormHelperText = showDescription
            ? description
            : !isValid
                ? errors
                : null;
        var secondFormHelperText = showDescription && !isValid ? errors : null;
        return (react_1.default.createElement(core_2.Hidden, { xsUp: !visible },
            react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: dayjs_1.default },
                react_1.default.createElement(pickers_1.KeyboardDatePicker, { id: id + '-input', required: required && !appliedUiSchemaOptions.hideRequiredAsterisk, label: label, error: !isValid, fullWidth: !appliedUiSchemaOptions.trim, InputLabelProps: data ? { shrink: true } : undefined, value: util_1.getData(data, saveFormat), clearable: true, onChange: util_1.createOnChangeHandler(path, handleChange, saveFormat), format: format, views: appliedUiSchemaOptions.views, disabled: !enabled, autoFocus: appliedUiSchemaOptions.focus, onFocus: this.onFocus, onBlur: this.onBlur, cancelLabel: appliedUiSchemaOptions.cancelLabel, clearLabel: appliedUiSchemaOptions.clearLabel, okLabel: appliedUiSchemaOptions.okLabel, leftArrowIcon: react_1.default.createElement(KeyboardArrowLeft_1.default, null), rightArrowIcon: react_1.default.createElement(KeyboardArrowRight_1.default, null), keyboardIcon: react_1.default.createElement(Event_1.default, null), invalidDateMessage: null, maxDateMessage: null, minDateMessage: null }),
                react_1.default.createElement(core_2.FormHelperText, { error: !isValid && !showDescription }, firstFormHelperText),
                react_1.default.createElement(core_2.FormHelperText, { error: !isValid }, secondFormHelperText))));
    };
    return MaterialDateControl;
}(react_2.Control));
exports.MaterialDateControl = MaterialDateControl;
exports.materialDateControlTester = core_1.rankWith(4, core_1.isDateControl);
exports.default = react_2.withJsonFormsControlProps(MaterialDateControl);
//# sourceMappingURL=MaterialDateControl.js.map